import { fromUtcMs } from './from-utc-ms';
import type { IsoDate } from './iso-date';
import { toUtcMs } from './to-utc-ms';

export function addDays(date: IsoDate, days: number): IsoDate {
  return fromUtcMs(toUtcMs(date) + days * 86_400_000);
}
